module.exports = __webpack_public_path__ + "img/electrician.1127c2c2.jpg";